<template>
  <Button
    :href="block.item.url"
    as="a"
    class="ag-block__button"
    rel="nofollow noindex"
    target="_blank"
    @click.prevent="onClick(block)"
  >
    <span>{{ block.item.text }}</span>
  </Button>
</template>

<script setup lang="ts">
import type { CTABlock } from '~/types/blocks'

defineProps<{
  block: CTABlock
}>()

const { onClick } = useBlock()
</script>

<style>
.ag-block--cta {
  .block-size-control {
    @apply right-0 top-0;
  }
}
</style>
